// Config for the "looks like you're from another country" bar (CountryNudgeBanner).
// Keys are ISO alpha-2 (uppercase), matching what geoIP returns (store/main.js clientLocation).
// name/prompt/question/button come from i18n: countryNudge.<CODE>.* (see locales/en.json).
export const countryNudgeConfig = {
  RU: { flag: '🇷🇺', url: 'https://gorillaenergy.ru/?locale=ru&lang=ru&fl=1' },
  AM: { flag: '🇦🇲', url: 'https://am.gorillaenergy.com' },
  CA: { flag: '🇨🇦', url: 'https://ca.gorillaenergy.com' },
  CY: { flag: '🇨🇾', url: 'https://cy.gorillaenergy.com' },
  FR: { flag: '🇫🇷', url: 'https://fr.gorillaenergy.com' },
  GE: { flag: '🇬🇪', url: 'https://ge.gorillaenergy.com' },
  KZ: { flag: '🇰🇿', url: 'https://kz.gorillaenergy.com' },
  KG: { flag: '🇰🇬', url: 'https://kg.gorillaenergy.com' },
  MD: { flag: '🇲🇩', url: 'https://md.gorillaenergy.com' },
  KR: { flag: '🇰🇷', url: 'https://ko.gorillaenergy.com' },
  SR: { flag: '🇸🇷', url: 'https://sr.gorillaenergy.com' },
  TR: { flag: '🇹🇷', url: 'https://gorillaenergy.com.tr' },
  TJ: { flag: '🇹🇯', url: 'https://tj.gorillaenergy.com' },
  AE: { flag: '🇦🇪', url: 'https://ae.gorillaenergy.com' },
  GB: { flag: '🇬🇧', url: 'https://uk.gorillaenergy.com' },
  US: { flag: '🇺🇸', url: 'https://us.gorillaenergy.com' },
  UZ: { flag: '🇺🇿', url: 'https://uz.gorillaenergy.com' }
}

// Where to send the user when their country is detected but has no dedicated site version.
export const globalFallback = { flag: '🌐', url: 'https://gorillaenergy.com' }

// Site version code (siteVersions.item.code) -> country ISO, to tell "am I already on my own site?".
export const siteCodeToIso = {
  ru: 'RU', am: 'AM', ca: 'CA', cy: 'CY', fr: 'FR', ge: 'GE', kz: 'KZ',
  kg: 'KG', md: 'MD', kr: 'KR', rs: 'RS', tr: 'TR', tj: 'TJ', ar: 'AE',
  gb: 'GB', uz: 'UZ', usa: 'US', global: 'GLOBAL'
}
